"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = require("styled-components");
var _startOfDay = _interopRequireDefault(require("date-fns/startOfDay"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _isSameDay = _interopRequireDefault(require("date-fns/isSameDay"));
var _isAfter = _interopRequireDefault(require("date-fns/isAfter"));
var _isBefore = _interopRequireDefault(require("date-fns/isBefore"));
var _endOfDay = _interopRequireDefault(require("date-fns/endOfDay"));
var _lodash = _interopRequireDefault(require("lodash.noop"));
var _oxygenConstants = require("@8x8/oxygen-constants");
var _oxygenConfig = require("@8x8/oxygen-config");
var StyledDay = _interopRequireWildcard(require("../styled/DayCell"));
var _constants = _interopRequireDefault(require("../constants"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Day = /*#__PURE__*/function (_PureComponent) {
  _inherits(Day, _PureComponent);
  var _super = _createSuper(Day);
  function Day() {
    var _this;
    _classCallCheck(this, Day);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "onKeyEvent", function (event) {
      var _this$props = _this.props,
        day = _this$props.day,
        isPassive = _this$props.isPassive,
        isDisabled = _this$props.isDisabled,
        onClick = _this$props.onClick;
      if (isPassive || isDisabled) {
        return;
      }
      if (event.keyCode === _oxygenConstants.keyCode.ENTER || event.keyCode === _oxygenConstants.keyCode.SPACE) {
        onClick(day);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseEvent", function (event) {
      var _this$props2 = _this.props,
        day = _this$props2.day,
        isPassive = _this$props2.isPassive,
        isDisabled = _this$props2.isDisabled,
        onClick = _this$props2.onClick,
        onPreviewChange = _this$props2.onPreviewChange;
      if (isPassive || isDisabled) {
        onPreviewChange();
        return;
      }
      switch (event.type) {
        case 'click':
          onClick(day);
          break;
        case 'focus':
        case 'mouseenter':
          onPreviewChange(day);
          break;
        case 'blur':
        case 'mouseleave':
          onPreviewChange();
          break;
        default:
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getSelectionProps", function () {
      var _this$props3 = _this.props,
        day = _this$props3.day,
        displayMode = _this$props3.displayMode,
        date = _this$props3.date,
        range = _this$props3.range;
      if (displayMode === _constants["default"].DATE) {
        if ((0, _isSameDay["default"])(day, date)) {
          return {
            isInRange: true,
            isStartEdge: true,
            isEndEdge: true,
            isVisible: true
          };
        }
        return {};
      }
      if (!range) {
        return {};
      }
      var startDate = range.startDate,
        endDate = range.endDate;
      return _this.getRangeProps(startDate, endDate);
    });
    _defineProperty(_assertThisInitialized(_this), "getPreviewProps", function () {
      var preview = _this.props.preview;
      if (!preview) {
        return {};
      }
      var startDate = preview.startDate,
        endDate = preview.endDate;
      return _this.getRangeProps(startDate, endDate);
    });
    _defineProperty(_assertThisInitialized(_this), "getRangeProps", function (start, end) {
      var day = _this.props.day;
      var startDate;
      var endDate;
      if (start && end && (0, _isBefore["default"])(end, start)) {
        startDate = end;
        endDate = start;
      } else {
        startDate = start;
        endDate = end;
      }
      startDate = startDate ? (0, _endOfDay["default"])(startDate) : null;
      endDate = endDate ? (0, _startOfDay["default"])(endDate) : (0, _startOfDay["default"])(startDate);
      var rangeProps = {};
      rangeProps.isInRange = (!startDate || (0, _isAfter["default"])(day, startDate)) && (!endDate || (0, _isBefore["default"])(day, endDate));
      rangeProps.isStartEdge = !rangeProps.isInRange && (0, _isSameDay["default"])(day, startDate);
      rangeProps.isEndEdge = !rangeProps.isInRange && (0, _isSameDay["default"])(day, endDate);
      rangeProps.isVisible = rangeProps.isInRange || rangeProps.isStartEdge || rangeProps.isEndEdge;
      return rangeProps;
    });
    return _this;
  }
  _createClass(Day, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        day = _this$props4.day,
        testId = _this$props4.testId,
        isToday = _this$props4.isToday,
        isPassive = _this$props4.isPassive,
        isDisabled = _this$props4.isDisabled,
        dayNumberFormat = _this$props4.dayNumberFormat,
        locale = _this$props4.locale,
        theme = _this$props4.theme,
        preview = _this$props4.preview;
      var selectionProps = this.getSelectionProps();
      var previewProps = this.getPreviewProps();
      var isEdge = selectionProps.isStartEdge || selectionProps.isEndEdge;
      return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
        theme: theme
      }, /*#__PURE__*/_react["default"].createElement(StyledDay.DayCell, _extends({
        type: "button",
        onClick: this.onMouseEvent,
        onMouseEnter: this.onMouseEvent,
        onMouseLeave: this.onMouseEvent,
        onFocus: this.onMouseEvent,
        onBlur: this.onMouseEvent,
        onKeyPress: this.onKeyEvent,
        isSelected: selectionProps.isVisible,
        isPassive: isPassive,
        isDisabled: isDisabled,
        isEdge: isEdge
      }, (0, _oxygenConfig.getTestAttributes)(testId)), !isPassive && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, selectionProps.isVisible && /*#__PURE__*/_react["default"].createElement(StyledDay.SelectionRange, _extends({}, selectionProps, {
        isDisabled: isDisabled
      }, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_SELECTION_RANGE_MIDDLE")))), preview && /*#__PURE__*/_react["default"].createElement(StyledDay.PreviewRange, _extends({}, previewProps, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_PREVIEW_RANGE")))), isEdge && /*#__PURE__*/_react["default"].createElement(StyledDay.SelectionRangeEdge, _extends({}, selectionProps, {
        isDisabled: isDisabled
      }, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_SELECTION_RANGE_EDGE"))))), /*#__PURE__*/_react["default"].createElement(StyledDay.NumberContainer, null, /*#__PURE__*/_react["default"].createElement(StyledDay.DayNumber, _extends({
        isToday: isToday
      }, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_NUMBER"))), (0, _format["default"])(day, dayNumberFormat, locale ? {
        locale: locale
      } : undefined)), isToday && /*#__PURE__*/_react["default"].createElement(StyledDay.TodayLine, _extends({
        isSelected: selectionProps.isVisible,
        isEdge: isEdge,
        isPassive: isPassive
      }, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_TODAY_LINE")))))));
    }
  }]);
  return Day;
}(_react.PureComponent);
Day.propTypes = {
  day: _propTypes["default"].object.isRequired,
  testId: _propTypes["default"].string,
  displayMode: _propTypes["default"].oneOf(Object.values(_constants["default"])),
  preview: _propTypes["default"].shape({
    startDate: _propTypes["default"].object,
    endDate: _propTypes["default"].object
  }),
  range: _propTypes["default"].shape({
    startDate: _propTypes["default"].object.isRequired,
    endDate: _propTypes["default"].object
  }),
  date: _propTypes["default"].object,
  isPassive: _propTypes["default"].bool,
  isDisabled: _propTypes["default"].bool,
  isToday: _propTypes["default"].bool,
  isWeekend: _propTypes["default"].bool,
  isStartOfWeek: _propTypes["default"].bool,
  isEndOfWeek: _propTypes["default"].bool,
  isStartOfMonth: _propTypes["default"].bool,
  isEndOfMonth: _propTypes["default"].bool,
  dayNumberFormat: _propTypes["default"].string,
  locale: _propTypes["default"].object,
  onClick: _propTypes["default"].func,
  onPreviewChange: _propTypes["default"].func,
  theme: _propTypes["default"].object.isRequired
};
Day.defaultProps = {
  testId: 'CALENDAR_DAY',
  displayMode: _constants["default"].DATE,
  preview: undefined,
  range: undefined,
  date: undefined,
  isPassive: false,
  isDisabled: false,
  isToday: false,
  isWeekend: false,
  isStartOfWeek: false,
  isEndOfWeek: false,
  isStartOfMonth: false,
  isEndOfMonth: false,
  dayNumberFormat: 'd',
  locale: undefined,
  onClick: _lodash["default"],
  onPreviewChange: _lodash["default"]
};
var _default = (0, _oxygenConfig.withTheme)(Day, 'calendar');
exports["default"] = _default;